import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <h2 className="section-title">Our Story</h2>
          <div className="story-content">
            <div className="story-text">
              <div className="story-item">
                <h3>How We Met</h3>
                <p>
                  We first met at a coffee shop in downtown Portland on a rainy Tuesday morning in 2020. 
                  Ashlynn was reading her favorite book, and Michael couldn't help but notice her beautiful 
                  smile. After gathering the courage to ask about the book, our conversation lasted for hours.
                </p>
              </div>
              <div className="story-item">
                <h3>The Proposal</h3>
                <p>
                  Three years later, Michael surprised Ashlynn with a romantic proposal at the same coffee shop 
                  where we first met. Surrounded by fairy lights and our favorite flowers, he got down on one 
                  knee and asked the question that changed our lives forever.
                </p>
              </div>
              <div className="story-item">
                <h3>Our Future</h3>
                <p>
                  We can't wait to start this new chapter of our lives together, surrounded by the love and 
                  support of our family and friends. Thank you for being part of our journey!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 